<script lang=ts>
      import { page } from "$app/state"
      import { getPayloadContext } from "../context/ts/PayloadGlobals.svelte"
      import { getMetaContext } from "./ts/MetaContext.svelte"


  const author = ""
  const copyright = ""
  const siteName = "Divadelní flora"

  const payload = getPayloadContext()
  const meta = getMetaContext()


  let title = $state("")
  let description = $state("")
  let imageUrl = $state("")
  let imageAlt = $state("")
  let url = $state( page.url.toString() )


  $effect( () => {
    title = meta.title ?? payload.seo?.defaultTitle ?? siteName
    description = meta.description ?? payload.seo?.defaultDescription ?? ""
    imageUrl = meta.imageUrl ?? payload.seo?.seoImage?.url?.sizes?.large?.url ?? payload.seo?.seoImage?.url ?? ""
  })

  title = meta.title ?? payload.seo?.defaultTitle ?? siteName
  description = meta.description ?? payload.seo?.defaultDescription ?? ""
  imageUrl = meta.imageUrl ?? payload.seo?.seoImage?.url?.sizes?.large?.url ?? payload.seo?.seoImage?.url ?? ""
  
  
</script>

<svelte:head>
  <title>{title}</title>
  <!--general-->
  <meta name="description" content="{description}">
  <meta name="author" content="{author}">
  <meta name="copyright" content="{copyright}">

  <!-- google -->
  <meta itemprop="name" content="{title}" />
  <meta itemprop="description" content="{description}" />
  <meta itemprop="image" content="{imageUrl}" />
  
  <!-- twitter -->
  <meta name="twitter:title" content="{title}">
  <meta name="twitter:description" content="{description}">
  <meta name="twitter:image" content="{imageUrl}">
  <meta name="twitter:image:alt" content="{imageAlt}">
  <meta name="twitter:card" content="summary_large_image">
  
  
  <!-- opengraph -->
  <meta property="og:title" content="{title}" />
  <meta property="og:image" content="{imageUrl}" />
  <meta property="og:url" content="{url}" />
  <meta property="og:type" content="article" />
  
  <meta property="og:site_name" content="{siteName}">
</svelte:head>